import React, { Suspense, useEffect,lazy } from 'react';
import { Navigate} from 'react-router-dom';

const Mbzer = lazy(()=>import('./muzer').then(mod=>({default:mod.Mbzer})));
const Muzer = lazy(()=>import('./muzer').then(mod=>({default:mod.Muzer})));

const Brotex = ({ user, children }) => {
    
    useEffect(() => {
        import('./muzer');
      }, []);

    if (Object.keys(user).length === 0) {
        return <Navigate to='/' />;
    };

    return(
        <Suspense fallback={<div></div>}>
            {user.brand ? <Mbzer/> : <Muzer/>}
        </Suspense>
    );
   
};

export default Brotex;